import React, {useEffect, useState} from 'react';
import Forms from './Forms';
import {useTranslation} from "react-i18next";
import crossIcon from "../assets/images/cross.svg";

const RepairEditorRepair = ({
    deviceList,
    repairData,
    onRepairChange,
    onRemoveRepair,
    disableDeviceSelection = false,
    hideRemoveRepair = false
}) => {
    const [repairOptions, setRepairOptions] = useState([]);
    const {t} = useTranslation();

    const handleRepairChange = (value) => {
        onRepairChange({...repairData, repairList: value});
    };

    const handleSelectedDevice = (device) => {
        const deviceId = device?.value || device?._id || device;
        const chosenDevice = deviceList.find(d => d._id === deviceId);
        setRepairOptions(chosenDevice?.repairList.map(r => ({
            label: `${r.repair.name} (${r.price} Kč)`,
            repairCatalogRepair: r.repair._id,
            deviceRepair: r._id,
            price: r.price
        })) || []);
        onRepairChange({device: deviceId ? {value: deviceId, label: chosenDevice?.name || device?.label || ''} : null, repairList: []});
    };

    useEffect(() => {
        if (!repairData?.device) return;
        const selectedDeviceId = repairData.device?.value || repairData.device;
        const chosenDevice = deviceList.find(d => d._id === selectedDeviceId);
        setRepairOptions(chosenDevice?.repairList.map(r => ({
            label: `${r.repair.name} (${r.price} Kč)`,
            repairCatalogRepair: r.repair._id,
            deviceRepair: r._id,
            price: r.price
        })) || []);
    }, [deviceList, repairData?.device]);

    const _renderRepairOptions = () => {
        if (repairData.device && !repairOptions.length) {
            return <label>{t('RepairEditorRepair.noAvailableRepairs')}</label>
        }

        return repairOptions.length > 0 && (
            <Forms.Select
                multiple
                required
                getOptionValue={option => option.repairCatalogRepair}
                placeholder={t('RepairEditorRepair.selectRepair')}
                value={repairData?.repairList || []}
                options={repairOptions}
                onChange={handleRepairChange}
            />
        )
    }

    return (
        <div className="grid grid-cols-[1fr_auto] gap-2 w-full mb-8">
            <div>
                <Forms.Select
                    required
                    placeholder={t('RepairEditorRepair.selectDevice')}
                    value={repairData.device}
                    options={deviceList.map(device => ({value: device._id, label: `${device.name}${device.code ? ` (${device.code})` : ''}`}))}
                    onChange={handleSelectedDevice}
                    disabled={disableDeviceSelection}
                />

                {_renderRepairOptions()}

            </div>
            {!hideRemoveRepair && (
                <div className="flex justify-center">
                    <img src={crossIcon} width={25} alt="delete icon" className="cursor-pointer"
                         onClick={onRemoveRepair}/>
                </div>
            )}
            {hideRemoveRepair && <div/>}
            <div className="separator col-span-2 mt-4"/>
        </div>
    );
};

export default RepairEditorRepair;
